import React from "react";

// Matches travel-qr VerifyLoader — fixed overlay with backdrop-blur
export default function TravelVerifyLoader({ show }) {
  if (!show) return null;
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255,255,255,0.6)",
      backdropFilter: "blur(3px)",
      WebkitBackdropFilter: "blur(3px)",
    }}>
      {/* Three-dot spinner matching source LottieWrapper dimensions */}
      <div style={{ display: "flex", gap: 10 }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{
            width: 14, height: 14, borderRadius: "50%",
            backgroundColor: "#079f9f",
            animation: `tvl-bounce 0.8s ease-in-out ${i * 0.15}s infinite alternate`,
          }} />
        ))}
      </div>
      <style>{`
        @keyframes tvl-bounce {
          from { transform: translateY(0); opacity:0.6; }
          to { transform: translateY(-16px); opacity:1; }
        }
      `}</style>
    </div>
  );
}
